import { FC } from 'react';

type Props = React.SVGProps<SVGSVGElement> & {
  color?: string;
  activeColor?: string;
  sortingOrder: 'asc' | 'desc' | null;
};
const ChevronDownIcon: FC<Props> = ({
  color = 'var(--gray-400)',
  activeColor = 'var(--gray-600)',
  sortingOrder,
  ...props
}) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 5L5 0L0 5Z"
        fill={sortingOrder === 'asc' ? activeColor : color}
      />
      <path
        d="M10 7L5 12L0 7Z"
        fill={sortingOrder === 'desc' ? activeColor : color}
      />
    </svg>
  );
};

export default ChevronDownIcon;
